import 'izitoast/dist/css/iziToast.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import './css/izitoast.css'

/**
 * Global error handler
 */

const defaultOptions = {
  layout: 3,
  theme: 'dark',
  position: 'bottomRight',
  timeout: 10000,
  close: false,
  icon: false,
  overlay: false,
  messageSize: '13px',
  messageColor: 'white',
  titleColor: 'white',
  messageLineHeight: 1.5,
  animateInside: false,
  transitionIn: 'fadeInLeft',
  transitionOut: 'fadeOutRight',
}

export default {
  error(message, options) {
    iziToast.error({
      message,
      ...defaultOptions,
      icon: 'ico-error',
      color: '#ff5252',
      buttons: [
        [
          '<button>X</button>',
          function (instance, toast) {
            instance.hide({}, toast)
          },
        ],
      ],
      ...options,
    })
  },
}
